import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, forwardRef, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { NumericFormat } from "react-number-format";
import { Card, CardBody, Nav, Row, Col, Modal, Button, Form, Stack } from "react-bootstrap";
import Select from "react-select";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import DatatableLayout from "layouts/DatatableLayout";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { formatNumber } from "utils/HelperFunction";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { getReportBrand } from "../../redux/handlers/report/getReportBrand.handler";
import { getReportBrandDetail } from "../../redux/handlers/report/getReportBrandDetail.handler";
import { getReportPurchasePendingConfirm } from "../../redux/handlers/report/getReportPurchasePendingConfirm.handler";
import { allSetUser } from "../../redux/handlers/manage/allSetUser.handler";
import { allBrand } from "../../redux/handlers/manage/allBrand.handler";
import DownloadExcel2 from "utils/DownloadExcel2";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import ReportDateRangeSelect, { getReportDateRange } from "layouts/ReportDateRangeSelect";
var purchasePendingSaleStatusOptions = [
    {
        value: 1,
        label: "รอติดต่อ"
    },
    {
        value: 2,
        label: "ยืนยันแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    }
];
var purchasePendingReserveStatusOptions = [
    {
        value: 1,
        label: "รอยืนยัน"
    },
    {
        value: 4,
        label: "กำลังจัดสินค้า"
    },
    {
        value: 7,
        label: "ตรวจสอบสินค้า"
    },
    {
        value: 5,
        label: "รอส่งสินค้า"
    },
    {
        value: 2,
        label: "ส่งสินค้าแล้ว"
    },
    {
        value: 6,
        label: "ชำระเงินแล้ว"
    },
    {
        value: 3,
        label: "ยกเลิก"
    }
];
var purchasePendingStatusWidgets = [
    {
        status: 1,
        label: "รอยืนยัน"
    },
    {
        status: 4,
        label: "กำลังจัดสินค้า"
    },
    {
        status: 7,
        label: "ตรวจสอบสินค้า"
    },
    {
        status: 5,
        label: "รอส่งสินค้า"
    },
    {
        status: 2,
        label: "ส่งสินค้าแล้ว"
    },
    {
        status: 6,
        label: "ชำระเงินแล้ว"
    }
];
var emptyPurchasePendingStatusSummary = {
    1: 0,
    2: 0,
    4: 0,
    5: 0,
    6: 0,
    7: 0
};
var sortOptionsByLabelAsc = function(options) {
    return _to_consumable_array(options).sort(function(a, b) {
        return String(a.label || "").localeCompare(String(b.label || ""), "en", {
            sensitivity: "base"
        });
    });
};
var SummaryBox = function(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ _jsxs("div", {
        className: "px-3 py-2 border rounded bg-light h-100",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "fs-14 tc-7",
                children: label
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "fs-20 fw-semibold",
                children: value
            })
        ]
    });
};
var integerText = function(value) {
    return formatNumber(Number(value || 0), 0) || "0";
};
export function ReportPurchaseByBrand() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionBrand = _useState1[0], setOptionBrand = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), brandId = _useState2[0], setBrandId = _useState2[1];
    // const [filBrand, setFilBrand] = useState([]);
    var _useState3 = _sliced_to_array(useState(null), 2), sDate = _useState3[0], setSDate = _useState3[1];
    var _useState4 = _sliced_to_array(useState(null), 2), eDate = _useState4[0], setEDate = _useState4[1];
    var _useState5 = _sliced_to_array(useState("custom"), 2), dateRange = _useState5[0], setDateRange = _useState5[1];
    var getReportBrandReducer = useAppSelector(function(state) {
        return state.getReportBrandReducer;
    });
    var allBrandReducer = useAppSelector(function(state) {
        return state.allBrandReducer;
    });
    // Load data
    useEffect(function() {
        dispatch(getReportBrand({
            sdate: sDate ? moment(sDate).format("YYYY-MM-DD") : "",
            edate: eDate ? moment(eDate).format("YYYY-MM-DD") : "",
            brandid: parseInt(brandId)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        brandId,
        sDate,
        eDate
    ]);
    useEffect(function() {
        dispatch(allBrand({
            status: 1
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(getReportBrandReducer.isFetching || allBrandReducer.isFetching);
        if (getReportBrandReducer.data) {
            var data = getReportBrandReducer.data.data;
            setDatalist(data);
        }
        if (allBrandReducer.data && !allBrandReducer.isError) {
            var rows = allBrandReducer.data.data || [];
            setOptionBrand([
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ].concat(_to_consumable_array(sortOptionsByLabelAsc(rows.map(function(brand) {
                return {
                    value: brand.set_brand_id,
                    label: brand.set_brand_name || brand.set_brand_nameen || "-"
                };
            })))));
        }
    }, [
        getReportBrandReducer,
        allBrandReducer
    ]);
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setSDate(range.startDate);
            setEDate(range.endDate);
        }
    };
    var columns = [
        {
            name: "วันที่จอง",
            selector: function(row) {
                return row.date;
            },
            center: "true"
        },
        {
            name: "แบรนด์",
            selector: function(row) {
                return row.set_brand_name;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/report/reportpurchasebrand/".concat(row.date, "/").concat(row.set_brand_name, "/").concat(row.pd_product_brandid),
                        children: row.set_brand_name ? row.set_brand_name : "-"
                    })
                });
            }
        },
        {
            name: "จำนวน SKU ทั้งหมด",
            selector: function(row) {
                return row.total_sku;
            },
            center: "true"
        },
        {
            name: "จำนวนร้านค้า",
            selector: function(row) {
                return row.total_shop;
            },
            center: "true"
        },
        {
            name: "จำนวน SKU ร้านค้า",
            selector: function(row) {
                return row.total_skushop;
            },
            center: "true"
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานสั่งซื้อตามแบรนด์สินค้า"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานสั่งซื้อตามแบรนด์สินค้า"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-xl-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "row gx-xl-4",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-2 col-md-4",
                                    children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                        value: dateRange,
                                        onChange: handleDateRangeChange,
                                        controlHeight: 38
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-5 col-md-12",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "row mt-[12px]",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-3 col-md-12",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    className: "mb-2",
                                                    children: "ค้นหาตามช่วงวันที่จอง"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-4 col-md-12",
                                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: sDate,
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        setSDate(date);
                                                    },
                                                    dateFormat: "dd-MM-yyyy",
                                                    className: "form-control px-2 mb-2",
                                                    isClearable: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-1 col-md-12",
                                                children: /*#__PURE__*/ _jsx("center", {
                                                    className: "mb-2",
                                                    children: "ถึง"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-4 col-md-12",
                                                children: /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: eDate,
                                                    onChange: function(date) {
                                                        setDateRange("custom");
                                                        setEDate(date);
                                                    },
                                                    dateFormat: "dd-MM-yyyy",
                                                    className: "form-control px-2 mb-2",
                                                    isClearable: true
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-xl-3 col-md-4",
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1 z-3",
                                                children: "ค้นหาแบรนด์"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                className: "w-100 select-st-3 z-2",
                                                placeholder: "ค้นหาแบรนด์",
                                                options: optionBrand,
                                                value: optionBrand.find(function(opt) {
                                                    return opt.value === brandId;
                                                }) || "",
                                                onChange: function(e) {
                                                    return setBrandId(e ? e.value : "");
                                                },
                                                isClearable: true
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body pt-0 px-0",
                        children: /*#__PURE__*/ _jsx(DatatableLayout, {
                            item: datalist,
                            columns: columns,
                            isSelectRows: false,
                            PerPage: 10
                        })
                    })
                ]
            })
        ]
    });
}
export function ReportPurchaseByBrandDetail() {
    var param = useParams();
    var detailID = useMemo(function() {
        return param.detailID ? param.detailID : null;
    }, [
        param.detailID
    ]);
    var dateVal = useMemo(function() {
        return param.dateVal ? param.dateVal : null;
    }, [
        param.dateVal
    ]);
    var brandName = useMemo(function() {
        return param.brandName ? param.brandName : null;
    }, [
        param.brandName
    ]);
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), optionShop = _useState1[0], setOptionShop = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), shopId = _useState2[0], setShopId = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionProduct = _useState3[0], setOptionProduct = _useState3[1];
    var _useState4 = _sliced_to_array(useState(""), 2), productId = _useState4[0], setProductId = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), optionSale = _useState5[0], setOptionSale = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), saleId = _useState6[0], setSaleId = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), filSale = _useState7[0], setFilSale = _useState7[1];
    var getReportBrandDetailReducer = useAppSelector(function(state) {
        return state.getReportBrandDetailReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    useEffect(function() {
        dispatch(getReportBrandDetail({
            brandid: parseInt(detailID),
            shopid: parseInt(shopId),
            saleid: parseInt(saleId),
            productid: parseInt(productId)
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        detailID,
        shopId,
        productId,
        saleId
    ]);
    useEffect(function() {
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(getReportBrandDetailReducer.isFetching || allSetUserReducer.isFetching);
        if (allSetUserReducer.data) {
            var op = allSetUserReducer.data.data;
            var all = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var arrSale = [];
            op.filter(function(v) {
                return v.sys_user_role_id === 3;
            }).map(function(ele) {
                return arrSale.push({
                    value: ele.sys_user_id,
                    label: "".concat(ele.sys_user_fullname, " ( ").concat(ele.sys_user_nname, " ) ")
                });
            });
            setOptionSale(_to_consumable_array(all).concat(_to_consumable_array(arrSale)));
        }
        if (getReportBrandDetailReducer.data) {
            var raw = getReportBrandDetailReducer.data.data;
            setDatalist(raw);
            var all1 = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            // **** Filter shShop
            // ใช้ Map กันไอดีซ้ำ
            var shopMap = new Map();
            raw.forEach(function(ele) {
                ele.shop.forEach(function(item) {
                    if (!shopMap.has(item.sh_shop_id)) {
                        shopMap.set(item.sh_shop_id, item.sh_shop_name);
                    }
                });
            });
            // แปลง Map -> array
            var uniqueShop = Array.from(shopMap, function(param) {
                var _param = _sliced_to_array(param, 2), value = _param[0], label = _param[1];
                return {
                    value: value,
                    label: label
                };
            });
            setOptionShop(_to_consumable_array(all1).concat(_to_consumable_array(uniqueShop)));
            // **** Filter pdProduct
            var productMap = new Map();
            raw.forEach(function(ele) {
                if (!productMap.has(ele.pd_product_id)) {
                    productMap.set(ele.pd_product_id, ele.pd_product_nameth);
                }
            });
            var productArr = Array.from(productMap, function(param) {
                var _param = _sliced_to_array(param, 2), value = _param[0], label = _param[1];
                return {
                    value: value,
                    label: label
                };
            });
            setOptionProduct(_to_consumable_array(all1).concat(_to_consumable_array(productArr)));
        }
    }, [
        getReportBrandDetailReducer,
        allSetUserReducer
    ]);
    var shopNames = useMemo(function() {
        if (!datalist || datalist.length === 0) return [];
        return datalist[0].shop.map(function(s) {
            return s.sh_shop_name;
        });
    }, [
        datalist
    ]);
    var tableData = useMemo(function() {
        return datalist.map(function(item) {
            var shopAmount = {};
            item.shop.forEach(function(s) {
                shopAmount[s.sh_shop_name] = s.total_amount;
            });
            return _object_spread_props(_object_spread({}, item), {
                shopAmount: shopAmount
            });
        });
    }, [
        datalist
    ]);
    var baseColumns = [
        {
            name: "รายการสินค้า",
            minWidth: "300px",
            selector: function(row) {
                return row.pd_product_nameth;
            }
        },
        {
            name: "จำนวนสินค้าทั้งหมด",
            selector: function(row) {
                return row.total_amount;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-center",
                    children: integerText(row.total_amount)
                });
            },
            center: true,
            width: "220px"
        },
        {
            name: "จำนวนร้านค้าทั้งหมด",
            selector: function(row) {
                return row.total_shop;
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-center",
                    children: integerText(row.total_shop)
                });
            },
            center: true,
            width: "220px"
        }
    ];
    var dynamicColumns = shopNames.map(function(name) {
        return {
            name: name,
            selector: function(row) {
                var _row_shopAmount_name;
                return (_row_shopAmount_name = row.shopAmount[name]) !== null && _row_shopAmount_name !== void 0 ? _row_shopAmount_name : "-";
            },
            center: true,
            width: "120px"
        };
    });
    // const columns = [...baseColumns, ...dynamicColumns];
    // const baseColumns = [
    //   {
    //     field: "pd_product_nameth",
    //     headerName: "รายการสินค้า",
    //     width: 350,
    //     flex: 1,
    //   },
    //   {
    //     field: "total_amount",
    //     headerName: "จำนวนสินค้าทั้งหมด",
    //     width: 170,
    //     align: "center",
    //     headerAlign: "center",
    //   },
    //   {
    //     field: "total_shop",
    //     headerName: "จำนวนร้านค้าทั้งหมด",
    //     width: 170,
    //     align: "center",
    //     headerAlign: "center",
    //   },
    // ];
    // const dynamicColumns = shopNames.map((name) => ({
    //   field: `shop_${name}`, // ต้องเป็น unique field
    //   headerName: name,
    //   width: 120,
    //   align: "center",
    //   headerAlign: "center",
    //   valueGetter: (row) => row?.shopAmount?.[name] ?? "-",
    // }));
    var columns = _to_consumable_array(baseColumns).concat(_to_consumable_array(dynamicColumns));
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายงานสั่งซื้อตามแบรนด์สินค้า"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายละเอียด"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายละเอียดการสั่งซื้อตามแบรนด์"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row gx-xl-4",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-3 col-md-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "fs-20 mb-2",
                                            children: [
                                                "แบรนด์ : ",
                                                brandName
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-3 col-md-3",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "fs-20 mb-2",
                                            children: [
                                                "วันที่ : ",
                                                moment(dateVal).format("DD-MM-YYYY")
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row gx-xl-4",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-4 col-md-6",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0 z-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาร้านค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาร้านค้า",
                                                    options: optionShop,
                                                    defaultValue: 0,
                                                    value: optionShop.find(function(opt) {
                                                        return opt.value === shopId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setShopId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-4 col-md-6",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0 z-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-3 ",
                                                    placeholder: "ค้นหาสินค้า",
                                                    options: optionProduct,
                                                    defaultValue: 0,
                                                    value: optionProduct.find(function(opt) {
                                                        return opt.value === productId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setProductId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-4 col-md-6",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 p-0 z-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาเซลล์"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    className: "w-100 select-st-3",
                                                    placeholder: "ค้นหาเซลล์",
                                                    options: optionSale,
                                                    defaultValue: 0,
                                                    value: optionSale.find(function(opt) {
                                                        return opt.value === saleId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        setSaleId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card-body pt-0 px-0",
                        style: {
                            overflowX: "auto"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("style", {
                                children: "\n            .pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n            .pinned-table .rdt_TableRow .rdt_TableCell:nth-child(1) {\n              position: sticky !important;\n              left: 0 !important;\n              z-index: 2 !important;\n              background-color: #ffffff !important;\n              box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;\n            }\n\n            .pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n            .pinned-table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n              position: sticky !important;\n              left: 300px !important;\n              z-index: 2 !important;\n              background-color: #ffffff !important;\n              box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;\n            }\n\n            .pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n            .pinned-table .rdt_TableRow .rdt_TableCell:nth-child(3) {\n              position: sticky !important;\n              left: 520px !important;\n              z-index: 2 !important;\n              background-color: #ffffff !important;\n              box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;\n            }\n\n            .pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n            .pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n            .pinned-table .rdt_TableHeadRow .rdt_TableCol:nth-child(3) {\n              z-index: 2 !important;\n              background-color: #F5F5F7 !important;\n            }\n          "
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "pinned-table",
                                children: /*#__PURE__*/ _jsx(DatatableLayout, {
                                    item: tableData,
                                    columns: columns,
                                    isSelectRows: false,
                                    PerPage: 10
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export function ReportPurchasePendingConfirm() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setIsLoading = useGlobalLoaderContext().setIsLoading;
    var _useState = _sliced_to_array(useState([]), 2), datalist = _useState[0], setDatalist = _useState[1];
    var _useState1 = _sliced_to_array(useState(emptyPurchasePendingStatusSummary), 2), statusSummary = _useState1[0], setStatusSummary = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), optionBrand = _useState2[0], setOptionBrand = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionProduct = _useState3[0], setOptionProduct = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), optionShop = _useState4[0], setOptionShop = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), optionSale = _useState5[0], setOptionSale = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), brandId = _useState6[0], setBrandId = _useState6[1];
    var _useState7 = _sliced_to_array(useState(""), 2), productId = _useState7[0], setProductId = _useState7[1];
    var _useState8 = _sliced_to_array(useState(""), 2), shopId = _useState8[0], setShopId = _useState8[1];
    var _useState9 = _sliced_to_array(useState(""), 2), saleId = _useState9[0], setSaleId = _useState9[1];
    var _useState10 = _sliced_to_array(useState([
        purchasePendingSaleStatusOptions[1]
    ]), 2), saleStatuses = _useState10[0], setSaleStatuses = _useState10[1];
    var _useState11 = _sliced_to_array(useState([
        purchasePendingReserveStatusOptions[0]
    ]), 2), reserveStatuses = _useState11[0], setReserveStatuses = _useState11[1];
    var _useState12 = _sliced_to_array(useState(null), 2), sDate = _useState12[0], setSDate = _useState12[1];
    var _useState13 = _sliced_to_array(useState(null), 2), eDate = _useState13[0], setEDate = _useState13[1];
    var _useState14 = _sliced_to_array(useState("custom"), 2), dateRange = _useState14[0], setDateRange = _useState14[1];
    var _useState15 = _sliced_to_array(useState({
        brandId: "",
        productId: "",
        shopId: "",
        saleId: "",
        saleStatuses: [
            purchasePendingSaleStatusOptions[1]
        ],
        reserveStatuses: [
            purchasePendingReserveStatusOptions[0]
        ],
        sDate: null,
        eDate: null
    }), 2), filters = _useState15[0], setFilters = _useState15[1];
    var getReportPurchasePendingConfirmReducer = useAppSelector(function(state) {
        return state.getReportPurchasePendingConfirmReducer;
    });
    var allBrandReducer = useAppSelector(function(state) {
        return state.allBrandReducer;
    });
    var allSetUserReducer = useAppSelector(function(state) {
        return state.allSetUserReducer;
    });
    var selectMenuProps = useMemo(function() {
        return {
            menuPortalTarget: typeof document !== "undefined" ? document.body : undefined,
            menuPosition: "fixed",
            styles: {
                menuPortal: function(base) {
                    return _object_spread_props(_object_spread({}, base), {
                        zIndex: 9999
                    });
                },
                menu: function(base) {
                    return _object_spread_props(_object_spread({}, base), {
                        zIndex: 9999
                    });
                }
            }
        };
    }, []);
    var handleSearch = function() {
        setFilters({
            brandId: brandId,
            productId: productId,
            shopId: shopId,
            saleId: saleId,
            saleStatuses: saleStatuses,
            reserveStatuses: reserveStatuses,
            sDate: sDate,
            eDate: eDate
        });
    };
    var handleDateRangeChange = function(preset) {
        setDateRange(preset);
        var range = getReportDateRange(preset);
        if (range) {
            setSDate(range.startDate);
            setEDate(range.endDate);
        }
    };
    useEffect(function() {
        dispatch(allBrand({
            status: 1
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        dispatch(allSetUser({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        dispatch(getReportPurchasePendingConfirm({
            sdate: filters.sDate ? moment(filters.sDate).format("YYYY-MM-DD") : "",
            edate: filters.eDate ? moment(filters.eDate).format("YYYY-MM-DD") : "",
            brandid: filters.brandId ? parseInt(filters.brandId, 10) : null,
            productid: filters.productId ? parseInt(filters.productId, 10) : null,
            shopid: filters.shopId ? parseInt(filters.shopId, 10) : null,
            saleid: filters.saleId ? parseInt(filters.saleId, 10) : null,
            salestatuses: (filters.saleStatuses || []).map(function(item) {
                return item.value;
            }),
            statuses: (filters.reserveStatuses || []).map(function(item) {
                return item.value;
            })
        }, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        filters
    ]);
    useEffect(function() {
        setIsLoading(getReportPurchasePendingConfirmReducer.isFetching || allBrandReducer.isFetching || allSetUserReducer.isFetching);
        if (getReportPurchasePendingConfirmReducer.data && !getReportPurchasePendingConfirmReducer.isError) {
            var response = getReportPurchasePendingConfirmReducer.data.data;
            var rows = Array.isArray(response) ? response : (response === null || response === void 0 ? void 0 : response.rows) || [];
            setStatusSummary(Array.isArray(response) ? emptyPurchasePendingStatusSummary : (response === null || response === void 0 ? void 0 : response.status_summary) || emptyPurchasePendingStatusSummary);
            var all = [
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ];
            var productMap = new Map();
            var shopMap = new Map();
            rows.forEach(function(row) {
                if (!productMap.has(row.pd_product_id)) {
                    productMap.set(row.pd_product_id, row.pd_product_nameth || "-");
                }
                (row.shop || []).forEach(function(shop) {
                    if (!shopMap.has(shop.sh_shop_id)) {
                        shopMap.set(shop.sh_shop_id, shop.sh_shop_name || "-");
                    }
                });
            });
            setDatalist(rows);
            setOptionProduct(_to_consumable_array(all).concat(_to_consumable_array(sortOptionsByLabelAsc(Array.from(productMap, function(param) {
                var _param = _sliced_to_array(param, 2), value = _param[0], label = _param[1];
                return {
                    value: value,
                    label: label
                };
            })))));
            setOptionShop(_to_consumable_array(all).concat(_to_consumable_array(sortOptionsByLabelAsc(Array.from(shopMap, function(param) {
                var _param = _sliced_to_array(param, 2), value = _param[0], label = _param[1];
                return {
                    value: value,
                    label: label
                };
            })))));
        }
        if (allBrandReducer.data && !allBrandReducer.isError) {
            var rows1 = allBrandReducer.data.data || [];
            setOptionBrand([
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ].concat(_to_consumable_array(sortOptionsByLabelAsc(rows1.map(function(brand) {
                return {
                    value: brand.set_brand_id,
                    label: brand.set_brand_name || brand.set_brand_nameen || "-"
                };
            })))));
        }
        if (allSetUserReducer.data && !allSetUserReducer.isError) {
            var users = allSetUserReducer.data.data || [];
            setOptionSale([
                {
                    value: "",
                    label: "ทั้งหมด"
                }
            ].concat(_to_consumable_array(sortOptionsByLabelAsc(users.filter(function(user) {
                return user.sys_user_role_id === 3;
            }).map(function(user) {
                return {
                    value: user.sys_user_id,
                    label: "".concat(user.sys_user_fullname, " ( ").concat(user.sys_user_nname, " ) ")
                };
            })))));
        }
    }, [
        getReportPurchasePendingConfirmReducer,
        allBrandReducer,
        allSetUserReducer
    ]);
    var shopNames = useMemo(function() {
        if (!datalist || datalist.length === 0) return [];
        return datalist[0].shop.map(function(s) {
            return s.sh_shop_name;
        });
    }, [
        datalist
    ]);
    var tableData = useMemo(function() {
        return datalist.map(function(item) {
            var shopAmount = {};
            item.shop.forEach(function(s) {
                shopAmount[s.sh_shop_name] = s.total_amount;
            });
            return _object_spread_props(_object_spread({}, item), {
                shopAmount: shopAmount
            });
        });
    }, [
        datalist
    ]);
    var summary = useMemo(function() {
        var shopSet = new Set();
        var reserveSet = new Set();
        return tableData.reduce(function(acc, row) {
            acc.total_product += 1;
            acc.total_product_amount_item += Number(row.total_amount || 0);
            if (Array.isArray(row.reserve_ids)) {
                row.reserve_ids.forEach(function(reserveId) {
                    if (reserveId) reserveSet.add(reserveId);
                });
            } else {
                acc.total_reserve += Number(row.total_reserve || 0);
            }
            (row.shop || []).forEach(function(shop) {
                if (Number(shop.total_amount || 0) > 0 && shop.sh_shop_id) {
                    shopSet.add(shop.sh_shop_id);
                }
            });
            acc.total_shop = shopSet.size;
            if (reserveSet.size > 0) {
                acc.total_reserve = reserveSet.size;
            }
            return acc;
        }, {
            total_product: 0,
            total_product_amount_item: 0,
            total_reserve: 0,
            total_shop: 0
        });
    }, [
        tableData
    ]);
    var excelData = useMemo(function() {
        return tableData.map(function(row) {
            var item = {
                รายการสินค้า: row.pd_product_nameth || "-",
                จำนวนที่จอง: row.total_amount || 0,
                จำนวนร้านค้าทั้งหมด: row.total_shop || 0
            };
            shopNames.forEach(function(name) {
                item[name] = row.shopAmount[name] || 0;
            });
            return item;
        });
    }, [
        tableData,
        shopNames
    ]);
    var columns = [
        {
            name: "รายการสินค้า",
            minWidth: "300px",
            selector: function(row) {
                return row.pd_product_nameth;
            }
        },
        {
            name: "จำนวนที่จอง",
            selector: function(row) {
                return integerText(row.total_amount);
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-center",
                    children: integerText(row.total_amount)
                });
            },
            center: true,
            width: "220px"
        },
        {
            name: "จำนวนร้านค้าทั้งหมด",
            selector: function(row) {
                return integerText(row.total_shop);
            },
            cell: function(row) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-center",
                    children: integerText(row.total_shop)
                });
            },
            center: true,
            width: "220px"
        }
    ].concat(_to_consumable_array(shopNames.map(function(name) {
        return {
            name: name,
            selector: function(row) {
                return row.shopAmount[name] ? integerText(row.shopAmount[name]) : "-";
            },
            cell: function(row) {
                var _row_shopAmount_name;
                var value = (_row_shopAmount_name = row.shopAmount[name]) !== null && _row_shopAmount_name !== void 0 ? _row_shopAmount_name : 0;
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-center",
                    style: {
                        color: Number(value) > 0 ? "#198754" : undefined
                    },
                    children: value ? integerText(value) : "-"
                });
            },
            center: true,
            width: "120px"
        };
    })));
    var _obj;
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7 text-decoration-none",
                                        children: "รายงานสั่งซื้อสินค้ารอยืนยัน"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "รายงานสั่งซื้อสินค้ารอยืนยัน"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-3 mb-3",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "gx-xl-4 align-items-end",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsx(ReportDateRangeSelect, {
                                            value: dateRange,
                                            onChange: handleDateRangeChange
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 6,
                                        md: 12,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "ค้นหาตามช่วงวันที่จอง"
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "d-flex gap-2 align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                            selected: sDate,
                                                            onChange: function(date) {
                                                                setDateRange("custom");
                                                                setSDate(date);
                                                            },
                                                            dateFormat: "dd-MM-yyyy",
                                                            className: "form-control px-2 input-equal",
                                                            placeholderText: "วันที่เริ่มต้น",
                                                            maxDate: eDate,
                                                            isClearable: true
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            children: "ถึง"
                                                        }),
                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                            selected: eDate,
                                                            onChange: function(date) {
                                                                setDateRange("custom");
                                                                setEDate(date);
                                                            },
                                                            dateFormat: "dd-MM-yyyy",
                                                            className: "form-control px-2 input-equal",
                                                            placeholderText: "วันที่สิ้นสุด",
                                                            minDate: sDate,
                                                            isClearable: true
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลือกแบรนด์"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "เลือกแบรนด์",
                                                    options: optionBrand
                                                }, selectMenuProps), {
                                                    value: optionBrand.find(function(opt) {
                                                        return opt.value === brandId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        return setBrandId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                }))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลือกสินค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "เลือกสินค้า",
                                                    options: optionProduct
                                                }, selectMenuProps), {
                                                    value: optionProduct.find(function(opt) {
                                                        return opt.value === productId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        return setProductId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                }))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลือกร้านค้า"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "เลือกร้านค้า",
                                                    options: optionShop
                                                }, selectMenuProps), {
                                                    value: optionShop.find(function(opt) {
                                                        return opt.value === shopId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        return setShopId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                }))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 2,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เลือกเซลล์"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "เลือกเซลล์",
                                                    options: optionSale
                                                }, selectMenuProps), {
                                                    value: optionSale.find(function(opt) {
                                                        return opt.value === saleId;
                                                    }) || "",
                                                    onChange: function(e) {
                                                        return setSaleId(e ? e.value : "");
                                                    },
                                                    isClearable: true
                                                }))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "สถานะเซลล์"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "สถานะเซลล์",
                                                    options: purchasePendingSaleStatusOptions
                                                }, selectMenuProps), {
                                                    value: saleStatuses,
                                                    onChange: function(items) {
                                                        return setSaleStatuses(items || []);
                                                    },
                                                    isMulti: true,
                                                    closeMenuOnSelect: false
                                                }))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: 3,
                                        md: 6,
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "สถานะ"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({
                                                    className: "w-100 select-st-3",
                                                    placeholder: "สถานะ",
                                                    options: purchasePendingReserveStatusOptions
                                                }, selectMenuProps), {
                                                    value: reserveStatuses,
                                                    onChange: function(items) {
                                                        return setReserveStatuses(items || []);
                                                    },
                                                    isMulti: true,
                                                    closeMenuOnSelect: false
                                                }))
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xl: "auto",
                                        md: 3,
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            variant: "danger",
                                            className: "mb-2",
                                            onClick: handleSearch,
                                            children: "ค้นหา"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Row, {
                                className: "g-2 mt-1",
                                children: purchasePendingStatusWidgets.map(function(item) {
                                    return /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 4,
                                        xl: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: item.label,
                                            value: integerText(statusSummary[item.status])
                                        })
                                    }, item.status);
                                })
                            }),
                            /*#__PURE__*/ _jsxs(Row, {
                                className: "g-2 mt-1 align-items-end",
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "จำนวนรายการสินค้า",
                                            value: integerText(summary.total_product)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "จำนวนที่จอง",
                                            value: integerText(summary.total_product_amount_item)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, {
                                            label: "จำนวนร้านค้า",
                                            value: integerText(summary.total_shop)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 6,
                                        md: 2,
                                        children: /*#__PURE__*/ _jsx(SummaryBox, (_obj = {
                                            label: "จำนวนร้านค้า"
                                        }, _define_property(_obj, "label", "จำนวนใบจอง"), _define_property(_obj, "value", integerText(summary.total_reserve)), _obj))
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        className: "d-flex align-items-end justify-content-end",
                                        children: /*#__PURE__*/ _jsx(DownloadExcel2, {
                                            data: excelData,
                                            filename: "รายงานสั่งซื้อสินค้ารอยืนยัน"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card-body pt-0 px-0",
                        style: {
                            overflowX: "auto"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("style", {
                                children: "\n            .purchase-pending-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n            .purchase-pending-table .rdt_TableRow .rdt_TableCell:nth-child(1) {\n              position: sticky !important;\n              left: 0 !important;\n              z-index: 2 !important;\n              background-color: #ffffff !important;\n              box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;\n            }\n\n            .purchase-pending-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n            .purchase-pending-table .rdt_TableRow .rdt_TableCell:nth-child(2) {\n              position: sticky !important;\n              left: 300px !important;\n              z-index: 2 !important;\n              background-color: #ffffff !important;\n              box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;\n            }\n\n            .purchase-pending-table .rdt_TableHeadRow .rdt_TableCol:nth-child(3),\n            .purchase-pending-table .rdt_TableRow .rdt_TableCell:nth-child(3) {\n              position: sticky !important;\n              left: 520px !important;\n              z-index: 2 !important;\n              background-color: #ffffff !important;\n              box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1) !important;\n            }\n\n            .purchase-pending-table .rdt_TableHeadRow .rdt_TableCol:nth-child(1),\n            .purchase-pending-table .rdt_TableHeadRow .rdt_TableCol:nth-child(2),\n            .purchase-pending-table .rdt_TableHeadRow .rdt_TableCol:nth-child(3) {\n              z-index: 3 !important;\n              background-color: #F5F5F7 !important;\n            }\n          "
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "purchase-pending-table",
                                children: /*#__PURE__*/ _jsx(DatatableLayout, {
                                    item: tableData,
                                    columns: columns,
                                    isSelectRows: false,
                                    PerPage: 10
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
